import { render, staticRenderFns } from "./ShowHearingDevices.vue?vue&type=template&id=55d1dd52"
import script from "./ShowHearingDevices.vue?vue&type=script&lang=js"
export * from "./ShowHearingDevices.vue?vue&type=script&lang=js"
import style0 from "./ShowHearingDevices.vue?vue&type=style&index=0&id=55d1dd52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports